/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Usage_S41_TitleInputs */

const es_privacy_policy_usage_s41_title = /** @type {(inputs: Privacy_Policy_Usage_S41_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4.1 Propositos Esenciales`)
};

const en_privacy_policy_usage_s41_title = /** @type {(inputs: Privacy_Policy_Usage_S41_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4.1 Essential Purposes`)
};

/**
* | output |
* | --- |
* | "4.1 Essential Purposes" |
*
* @param {Privacy_Policy_Usage_S41_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_usage_s41_title = /** @type {((inputs?: Privacy_Policy_Usage_S41_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Usage_S41_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_usage_s41_title(inputs)
	return en_privacy_policy_usage_s41_title(inputs)
});
export { privacy_policy_usage_s41_title as "privacy_policy.usage.s41_title" }